module.exports = __webpack_public_path__ + "img/bg-3.bb2afd34.jpg";